var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 16.6673C9.07944 16.6673 8.33325 15.9211 8.33325 15.0007C8.33325 14.0802 9.07944 13.334 9.99992 13.334C10.9204 13.334 11.6666 14.0802 11.6666 15.0007C11.6666 15.9211 10.9204 16.6673 9.99992 16.6673ZM9.99992 11.6673C9.07944 11.6673 8.33325 10.9211 8.33325 10.0007C8.33325 9.08018 9.07944 8.33398 9.99992 8.33398C10.9204 8.33398 11.6666 9.08018 11.6666 10.0007C11.6666 10.4427 11.491 10.8666 11.1784 11.1792C10.8659 11.4917 10.4419 11.6673 9.99992 11.6673ZM9.99992 6.66732C9.07944 6.66732 8.33325 5.92113 8.33325 5.00065C8.33325 4.08018 9.07944 3.33398 9.99992 3.33398C10.9204 3.33398 11.6666 4.08018 11.6666 5.00065C11.6666 5.44268 11.491 5.8666 11.1784 6.17916C10.8659 6.49172 10.4419 6.66732 9.99992 6.66732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.b59d57262b27074eba6cc1e48a9668e0.svg";
export { ForwardRef as ReactComponent };